import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  height: 1.5rem;
`;
